import { newAxiosIns } from '@/libs/axios'

/**
 * GET /contact/order/list - Get list of contact orders
 * @param {Object} params - Query parameters
 * @param {string} [params.product] - IDs of products (e.g. "1,2,3")
 * @param {string} [params.address] - Address (e.g. "banjar,bogor")
 * @param {number} [params.order_min] - Minimum order
 * @param {number} [params.order_max] - Maximum order
 * @param {number} [params.order_amount_min] - Minimum order amount
 * @param {number} [params.order_amount_max] - Maximum order amount
 * @param {string} [params.order_date_min] - Minimum order date (date-time)
 * @param {string} [params.order_date_max] - Maximum order date (e.g. "2021-05-20 14:19:23")
 * @param {string} [params.payment_method] - Payment method filter (e.g. "COD,BANK_TRANSFER")
 * @param {string} [params.status_order] - Status order filter (e.g. "review,reject")
 * @param {string} [params.type] - Filter by type (e.g. "komchat_ai")
 * @param {number} [params.limit] - Limit (pagination)
 * @param {number} [params.offset] - Offset (pagination)
 * @returns {Promise} Response: { meta, data: { count, data: [{ id, name, phone, address }] } }
 */
export function apiGetContactOrderList(params = {}) {
  return newAxiosIns.get('/komship/api/v1/contact/order/list', { params })
}

/**
 * GET /contact/order/filter - Get filters for contact orders
 * @param {Object} [params] - Query parameters
 * @param {string} [params.type] - Filter contact orders by type (e.g. "komchat_ai")
 * @returns {Promise} Response with filter options (product, address, payment_method, total_order, etc.)
 */
export function apiGetContactOrderFilter(params = {}) {
  return newAxiosIns.get('/komship/api/v1/contact/order/filter', { params })
}

/**
 * POST /api/v2/contact/komship/import - Import From Komship
 * @param {Object} filterContact - Filter contact payload
 * @param {string} [filterContact.product] - Product IDs (e.g. "123456")
 * @param {string} [filterContact.address] - Address (e.g. "purbalingga,temanggung")
 * @param {number} [filterContact.order_min] - Min order
 * @param {number} [filterContact.order_max] - Max order
 * @param {number} [filterContact.order_amount_min] - Min order amount
 * @param {number} [filterContact.order_amount_max] - Max order amount
 * @param {string} [filterContact.order_date_min] - Min date (e.g. "2025-02-01")
 * @param {string} [filterContact.order_date_max] - Max date (e.g. "2025-02-10")
 * @param {string} [filterContact.payment_method] - Payment method (e.g. "COD")
 * @param {number} [filterContact.total_contact] - Total contact to import
 * @param {string} [filterContact.status_order] - Status order (e.g. "review,reject")
 * @param {string} [filterContact.type] - Type (e.g. "komchat_ai")
 * @returns {Promise}
 */
export function apiImportContactFromKomship(filterContact) {
  return newAxiosIns.post(
    '/komchat-api/api/v2/contact/komship/import',
    filterContact,
  )
}

/**
 * GET /api/v1/contact/import/meta - Get Meta Contact List
 * @param {Object} [params] - Query parameters
 * @param {string} [params.interaction_level] - Interaction level filter (e.g. "low" or "high")
 * @param {string} [params.created_at_min] - Min created date
 * @param {string} [params.created_at_max] - Max created date
 * @returns {Promise} Response: { meta, data: [{ id, name, phone }] }
 */
export function apiGetMetaContactList(params = {}) {
  return newAxiosIns.get('/komchat-api/api/v1/contact/import/meta', { params })
}
